import { ViewAsStudentParams } from "#core/models/viewAsStudentParams.interface";
import { ClassLinkLoginRequest, CleverLoginRequest, Login, ResetPwdRequest, SampleCenterRequest, ThumbnailResponse, UpdateProfileRequest } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import { PPUser as User } from "cli-types";

/** General User Login Action */
export const userLoginAttempt = createAction(
    "[Login] Attempt",
    props<{ payload: Login }>()
);
export const userLoginSuccess = createAction(
    "[Login] Success",
    props<{ payload: User }>()
);
export const userLoginFail = createAction(
    "[Login] Fail",
    props<{ payload: any }>()
);

/** Clever User Login */
export const userCleverLoginAttempt = createAction(
    "[Clever Login] Attempt",
    props<{ payload: CleverLoginRequest }>()
);
export const userCleverLoginFail = createAction(
    "[Clever Login] Fail",
    props<{ payload: any }>()
);
export const userCleverLoginNoToken = createAction("[Clever Login] No Token");

/** ClassLink User Login */
export const userClassLinkLoginAttempt = createAction(
    "[ClassLink Login] Attempt",
    props<{ payload: ClassLinkLoginRequest }>()
);
export const userClassLinkLoginFail = createAction(
    "[ClassLink Login] Fail",
    props<{ payload: any }>()
);
export const userClassLinkLoginNoToken = createAction(
    "[ClassLink Login] No Token"
);

/** Sample Center User Login */
export const userSampleCenterLoginAttempt = createAction(
    "[Sample Center Login] Attempt",
    props<{ payload: SampleCenterRequest }>()
);
export const userSampleCenterLoginFail = createAction(
    "[Sample Center Login] Fail",
    props<{ payload: any }>()
);
export const userSampleCenterLoginSuccess = createAction(
    "[Sample Center Login] Fail"
);
export const userSampleCenterLoginNoToken = createAction(
    "[Sample Center Login] No Token"
);
export const userSampleCenterRedirect = createAction(
    "[Sample Center] Redirecting"
);
export const userMyCLRedirect = createAction(
    "[MyCL] Redirecting"
);

/** General User Logout */
export const userLogout = createAction(
    "[Login] Logout",
    props<{signout:boolean}>()
);
export const userLogoutMetaReducer = createAction("[Login] Logout Meta"); // Meta reducer gets called to clear store
export const userRedirect = createAction("[Login] Redirect");
export const userLoginMaintenance = createAction("[Login] Maintenance");

/** User Profile Basic Retrieve */
export const userProfileAttempt = createAction("[Profile] Attempt");
export const userProfileSuccess = createAction(
    "[Profile] Success",
    props<{ payload: any }>()
);
export const userProfileFail = createAction(
    "[Profile] Fail",
    props<{ payload: any }>()
);
export const userProfileSave = createAction(
    "[Profile] Save",
    props<{ payload: any }>()
);



/** User Profile Data */
export const userProfileRefresh = createAction("[Profile] Refresh");
export const userProfileUpdated = createAction(
    "[Profile] Updated",
    props<{ payload: any }>()
);

/** User Profile Pic */
export const userProfileWebcam = createAction(
    "[Profile] Webcam",
    props<{ stream: any }>()
);
export const userProfilePicAttempt = createAction("[Profile] Pic Attempt");
export const userProfilePicSuccess = createAction(
    "[Profile] Pic Success",
    props<{ payload: ThumbnailResponse }>()
);
export const userProfilePicFail = createAction("[Profile] PIC Fail");

/** User Profile Form Update */
export const userProfileUpdateAttempt = createAction(
    "[Profile] Update Attempt",
    props<{ payload: UpdateProfileRequest }>()
);
export const userProfileUpdateSuccess = createAction(
    "[Profile] Update Success",
    props<{ data: any }>()
);
export const userProfileUpdateFail = createAction(
    "[Profile] Update Fail",
    props<{ data: any }>()
);

/** User Profile Other */
export const userTempPwdDetected = createAction("[Profile] Temp Pwd Detected");
export const setViewAsStudentProfileData = createAction(
    "[Profile] Set View As Student Profile Data",
    props<{ payload: ViewAsStudentParams }>()
);
export const clearViewAsStudentProfileData = createAction(
    "[Profile] Clear View As Student Profile Data"
);
export const setLastCourse = createAction(
    "[Login] Set Last Course",
    props<{ courseID: number | null }>()
);

/** Retrieve FIDO User info */
export const loadFidoUserData = createAction(
    "[Profile] FIDO Retrieve Data",
    props<{ fidoUserID: string }>()
);
export const loadFidoUserDataSuccess = createAction(
    "[Profile] FIDO Retrieve Data Success",
    props<{ fidoUserData: any }>()
);
export const loadFidoUserDataFail = createAction(
    "[Profile] FIDO Retrieve Data Fail",
    props<{ data: any }>()
);

/** Retrieve FIDO User School and District Info */
export const loadFidoUserSchoolDistrictData = createAction(
    "[Profile] FIDO Retrieve School & District Data"
);
export const loadFidoUserSchoolDistrictDataSuccess = createAction(
    "[Profile] FIDO Retrieve School & District Data Success"
);
export const loadFidoUserSchoolDistrictDataFail = createAction(
    "[Profile] FIDO Retrieve School & District Data Fail"
);

/** HTTP Errors */
export const http503 = createAction("[HTTP] 503");
export const http403 = createAction("[HTTP] 403");
export const noAction = createAction("[Login] No Action");

/** User Notification Counters */
export const userProfileDecrementUnreadNotificationCount = createAction(
    "[Profile] DecUnreadNotificationsCount"
);
export const userProfileSetUnreadNotificationCount = createAction(
    "[Profile] SetUnreadNotificationsCount",
    props<{ payload: number }>()
);

/** User Reset State Actions */
export const userLoginResetState = createAction("[Login] Reset State");
export const userProfileResetState = createAction("[Profile] Reset State");

/** User Reset Password password */
export const userResetPwdNoHash = createAction(
    "[Login] Reset Password No Hash Found"
);
export const userResetPwdAttempt = createAction(
    "[Login] Reset Password Attempt",
    props<{ payload: ResetPwdRequest }>()
);
export const userResetPwdSuccess = createAction(
    "[Login] Reset Password Success"
);
export const userResetPwdFail = createAction("[Login] Reset Password Fail");
